import { createRouter, createWebHistory } from 'vue-router'

// Import route modules
import auth from './auth'
import authMiddleware from '@/Middleware/auth';
import hoteliers from './hoteliers';
import adminHotel from './adminHotel';
import adminActivity from './adminActivity';
import adminAdministrator from './adminAdministrator';
import adminExternalData from "./adminExternalData";
import { useExternalDataStore } from "../Store/externalData";
import { useSurveyDataStore } from '../Store/surveyData';
import adminEArrival from './adminEArrival';
import adminSurvey from './adminSurvey';
import publicSurvey from './publicSurvey';
import publicRoute from './public';

const routes = [
    ...auth,

    ...hoteliers,

    ...adminHotel,
    ...adminActivity,
    ...adminAdministrator,
    ...adminExternalData,
    ...adminEArrival,
    ...adminSurvey,
    ...publicSurvey,
    ...publicRoute,

    {
        path: '/landing-page',
        name: 'landing-page',
        component: () => import('@/Pages/LandingPage.vue'),
        meta: { layout: 'AdminLayout', requiresAuth: true }
    },
    {
        path: '/profile',
        name: 'profile',
        component: () => import('@/Pages/Profile/Show.vue'),
        meta: { layout: 'AdminLayout', requiresAuth: true }
    },
    {
        path: '/profile/edit',
        name: 'profile-edit',
        component: () => import('@/Pages/Profile/Edit.vue'),
        meta: { layout: 'AdminLayout', requiresAuth: true }
    },
    {
        path: '/',
        name: 'index-page',
        redirect: { name: 'landing-page' }
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    document.title = to.meta?.title || "TDD Brunei";
    authMiddleware({ to, from, next });
});

router.beforeEach((to, from, next) => {
    const store = useExternalDataStore();
    const isFromExternalData =
        from.name && from.name.includes("admin-external");
    const isToExternalData = to.name && to.name.includes("admin-external");
    const isLeavingExternalData = isFromExternalData && !isToExternalData;

    if (isLeavingExternalData) store.clearSession();

    if (to.name === "admin-external-data-show") {
        if (!store.selectedType) {
            store.restoreFromStorage();
        }
        if (!store.shouldAutoRedirect()) {
            store.clearType();
            return next({ name: "admin-external-data-select" });
        }

        return next();
    }

    if (to.name === "admin-external-data") {
        if (!store.selectedType) {
            store.restoreFromStorage();
        }
        if (!store.shouldAutoRedirect()) {
            store.clearType();
            return next({ name: "admin-external-data-select" });
        }

        return next();
    }

    if (to.name === "admin-external-dashboard") {
        if (!store.selectedType) {
            store.restoreFromStorage();
        }

        if (!store.shouldAutoRedirect()) {
            store.clearType();
            return next({ name: "admin-external-data-select" });
        }

        return next();
    }

    if (to.name === "admin-external-data-select") {
        if (!isFromExternalData) {
            store.clearType();
        }
    }
    next();
});

router.beforeEach((to, from, next) => {
    const store = useSurveyDataStore();
    const isFromSurveyData =
        from.name && from.name.includes("admin-survey");
    const isToSurveyData = to.name && to.name.includes("admin-survey");
    const isLeavingSurveyData = isFromSurveyData && !isToSurveyData;
    if (isLeavingSurveyData) store.clearSession();

    const needsType = [
        "admin-survey-data",
        "admin-survey-data-show",
        "admin-survey-data-edit",
        "admin-survey-dashboard",
        "admin-survey-questionnaire",
        "admin-survey-questionnaire-show"
    ].includes(to.name || "");

    if (needsType) {
        if (!store.selectedType) {
            store.restoreFromStorage();
        }

        if (!store.shouldAutoRedirect()) {
            store.clearType();
            return next({ name: "admin-survey-data-select" });
        }
        return next();
    }

    if (to.name === "admin-survey-data-select") {
        if (!isFromSurveyData) {
            store.clearType();
        }
    }
    next();
});

export default router;
